import { observer } from 'mobx-react';
import { Link } from '../../../../../../../Resource/Types';
import GenericSideLoadFilter from '../../../../../../People/Filters/GenericSideLoadFilter';
import InvitationsStore from '../../../Store';

interface Props {
  link: Link;
  invitationsStore: InvitationsStore;
}

function ProgramFamiliesFilter({ link, invitationsStore }: Props) {
  return (
    <GenericSideLoadFilter
      link={link}
      updatingSearchParameters={invitationsStore.updatingSearchParameters}
      searchParameters={invitationsStore.searchParameters}
      labelText="Program"
      filterKey="program_family"
    />
  );
}

export default observer(ProgramFamiliesFilter);
